module.exports = function() {
  return new Worker(__webpack_public_path__ + "618e109b65df05785a0d.worker.js");
};